var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomizableUi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_372_2424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3375 0.125H39.0875C37.1375 0.125 35.55 1.7125 35.55 3.6625V24.9125C35.55 26.8625 37.1375 28.45 39.0875 28.45H60.3375C62.2875 28.45 63.875 26.8625 63.875 24.9125V3.6625C63.875 1.7125 62.2875 0.125 60.3375 0.125Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9125 35.5375H3.6625C1.7125 35.5375 0.125 37.125 0.125 39.0875V60.3375C0.125 62.2875 1.7125 63.875 3.6625 63.875H24.9125C26.8625 63.875 28.45 62.2875 28.45 60.3375V39.0875C28.4625 37.125 26.875 35.5375 24.9125 35.5375Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9125 0.125H3.6625C1.7125 0.125 0.125 1.7125 0.125 3.6625V24.9125C0.125 26.8625 1.7125 28.45 3.6625 28.45H24.9125C26.8625 28.45 28.45 26.8625 28.45 24.9125V3.6625C28.4625 1.7125 26.875 0.125 24.9125 0.125Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.25 39.0874H46.1625V46.1624H39.0875V53.2499H46.1625V60.3374H53.25V53.2499H60.3375V46.1624H53.25V39.0874Z",
    fill: "#47ADB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_372_2424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizableUi);
export default __webpack_public_path__ + "static/media/CustomizableUI.1488c0b4042add30ca984fa7ad77a3a3.svg";
export { ForwardRef as ReactComponent };